import { css } from "@emotion/react";

import { colors } from "@styles";

export const productSize = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${colors.grey.darkFamily.light};
`;
